// extracted by mini-css-extract-plugin
module.exports = {"card":"BookItem_card__2YwSE","price":"BookItem_price__1DFc_"};